<!-- 打印商家券接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {"traderCode":"789","couponSn":"SDF235R23D"},
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台打印电子券，调用此接口后标记券已被发放，调用查询可用的电子券接口不会再次查询到同一张券",
                t_url: this.commonUrls.test+"printCoupon",
                p_url: this.commonUrls.prod+"printCoupon",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'traderCode', info2: '是', info3: 'String', info4: '授权商对应的商家代号' },
                        { info1: 'couponSn', info2: '是', info3: 'String', info4: '券的唯一编号' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/coupon/printCoupon.vue